import { Injectable } from '@angular/core';
import type { GlobalBasicSearchQueryInterface } from '@zaoblako/shared/common/dtos/search/global.basic.search.query.dto';
import type { GlobalBasicSearchResultInterface } from '@zaoblako/shared/common/dtos/search/global.basic.search.result.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService extends BaseService {
  protected baseUrl = '/search/basic';

  public search(queryParams: GlobalBasicSearchQueryInterface): Observable<GlobalBasicSearchResultInterface> {
    return this.http.get<GlobalBasicSearchResultInterface>(this.baseUrl, { params: this.objectToHttpParams(queryParams) });
  }
}
